export enum EdoEducationalStage {
  INFANZIA = 'INFANZIA',

  PRIMARIA = 'PRIMARIA',

  SECONDARIA_I = 'SECONDARIA_I',

  SECONDARIA_II = 'SECONDARIA_II',
}
